import { setSessionStorageItem } from './sessionStorage'

const SOURCE_DOMAINS = [
  {
    label: 'Facebook',
    links: ['facebook.com', 'fb.me']
  },
  {
    label: 'Instagram',
    links: ['instagram.com']
  },
  {
    label: 'LinkedIn',
    links: ['linkedin.com', 'lnkd.in', 'linkedin.android']
  },
  {
    label: 'Pintrest',
    links: ['pinterest']
  },
  {
    label: 'Reddit',
    links: ['reddit.com']
  },
  {
    label: 'Tiktok',
    links: [
      'tiktok.com',
      'tiktokcdn-in.com',
      'tiktokcdn.com',
      'tiktokv.com',
      'ttlivecdn.com',
      'musical.ly'
    ]
  },
  {
    label: 'Twitter',
    links: ['twitter.com']
  },
  {
    label: 'GitHub',
    links: ['github.com']
  },
  {
    label: 'YouTube',
    links: ['youtube.com', 'youtu.be']
  },
  {
    label: 'Vimeo',
    links: ['vimeo.com']
  }
]

const checkSocialDomains = () => {
  if (!navigator || !navigator.cookieEnabled) return {}
  const docReferrer =
    typeof document !== 'undefined' && document.referrer && new URL(document.referrer)

  const utm_medium = 'Organic'
  const utm_source = 'Social'

  if (!('utm_campaign' in sessionStorage)) {
    if (docReferrer && docReferrer.hostname) {
      setSessionStorageItem('utm_medium', utm_medium)
      setSessionStorageItem('utm_source', utm_source)
      SOURCE_DOMAINS.map(item => {
        if (item.links.some(se => docReferrer.hostname.includes(se))) {
          const utm_source = 'Social'
          const utm_campaign = item.label
          setSessionStorageItem('utm_source', utm_source)
          setSessionStorageItem('utm_campaign', utm_campaign)
          if (utm_campaign === 'undefined' || undefined) {
            const utm_medium = 'referral'
            const utm_source = docReferrer.hostname
            setSessionStorageItem('utm_medium', utm_medium)
            setSessionStorageItem('utm_source', utm_source)
          }
          return { utm_campaign, utm_medium, utm_source }
        } else {
          const utm_campaign = docReferrer.hostname
          setSessionStorageItem('utm_campaign', utm_campaign)
          const utm_source = docReferrer.host
          if (utm_source === 'websummit.com' || 'collisionconf.com'){
            setSessionStorageItem('utm_source', 'unknown')
          } else {
            setSessionStorageItem('utm_source', utm_source)
          }
          return { utm_campaign, utm_medium, utm_source }
        }
        return {}
      })
    }
  }
  return {}
}

export default checkSocialDomains
